var _rect, _g, _g2, _path, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_18165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_18165)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_283_18165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2935 8.07516L42.4462 15.8043L32.0085 19.6172L33.5695 8.61391C33.6878 7.77982 34.7213 7.45685 35.2935 8.07516Z",
    fill: "url(#paint0_linear_283_18165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.824 22.3277L21.8247 26.021L13.8659 33.776L10.5272 23.5769C10.267 22.782 11.0394 22.038 11.824 22.3277Z",
    fill: "url(#paint1_linear_283_18165)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_283_18165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7036 25.9691L45.6455 4.73738C45.3178 3.96915 44.2484 3.91745 43.8481 4.65048L38.3336 14.7478C37.9159 15.5127 36.9776 15.8239 36.1856 15.4603L17.1974 6.74311C16.5109 6.42794 15.7363 6.95853 15.7821 7.71255L16.9919 27.63C17.0512 28.6056 16.2584 29.4207 15.2816 29.3886L2.00927 28.9521C1.14683 28.9237 0.654982 29.9235 1.21031 30.584C5.78786 36.0283 13.1802 44.6332 16.7872 49.1121C17.7648 50.3262 19.3392 50.9348 20.8546 50.5695C39.018 46.1906 50.1797 35.582 54.4295 29.4406C55.136 28.4196 55.1908 27.1111 54.7036 25.9691Z",
    fill: "url(#paint2_linear_283_18165)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_283_18165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 55,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3172 25.0636L45.6455 4.73738C45.3178 3.96915 44.2484 3.91745 43.8481 4.65048L38.3336 14.7478C37.9159 15.5127 36.9776 15.8239 36.1856 15.4603L17.1974 6.74311C16.5109 6.42794 15.7363 6.95853 15.7821 7.71255L16.9919 27.63C17.0512 28.6056 16.2584 29.4207 15.2816 29.3886L2.00927 28.9521C1.14683 28.9237 0.654982 29.9235 1.21031 30.584C5.46884 35.6489 12.1636 43.4492 15.9801 48.1181C17.46 49.9283 19.83 50.8494 22.0923 50.2587C38.7712 45.9038 49.3337 36.3194 53.8531 30.2431C54.9645 28.7488 55.048 26.7765 54.3172 25.0636Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_283_18165)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_283_18165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0801 1.77051C43.4825 9.19279 41.2627 19.7567 34.8317 14.6325C36.4384 12.522 42.4429 5.10962 45.0801 1.77051Z",
    fill: "url(#paint3_linear_283_18165)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_283_18165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 29C8.38163 30.776 18.925 33.8037 16.7646 25.994C14.1664 26.5277 5.15203 28.07 1 29Z",
    fill: "url(#paint4_linear_283_18165)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2711 33.6772C37.1518 33.7577 37.0115 33.8071 36.8332 33.8218L34.083 34.0777C34.0123 34.0802 33.9287 34.1064 33.8492 34.1601C33.7796 34.207 33.714 34.2814 33.6783 34.3357L32.429 36.7942C32.3587 36.9473 32.2604 37.0589 32.1212 37.1529C31.8826 37.3139 31.577 37.3541 31.2919 37.2748C31.0068 37.1955 30.7792 36.9868 30.651 36.711L29.4707 34.126C29.3926 33.9674 29.2449 33.8558 29.0754 33.8191L26.3659 33.2777C25.9832 33.2039 25.6797 32.9256 25.5691 32.5474C25.4585 32.1691 25.5601 31.7836 25.8332 31.5237L27.8292 29.6785C27.9544 29.5638 28.0206 29.3832 27.9963 29.2185L27.5624 26.4317C27.5056 26.0473 27.665 25.6831 27.9732 25.4751C28.2814 25.2671 28.6788 25.2556 29.0139 25.452L31.4361 26.8969C31.5967 26.9848 31.772 26.9873 31.9252 26.9141L34.3832 25.7534C34.7264 25.5972 35.1219 25.6473 35.4243 25.881C35.7337 26.125 35.8782 26.5106 35.8135 26.8864L35.3189 29.6054C35.2795 29.783 35.3377 29.955 35.4556 30.0868L37.3944 32.1447C37.6022 32.3668 37.7105 32.656 37.6774 32.9501C37.6613 33.2478 37.5097 33.5162 37.2711 33.6772Z",
    fill: "url(#paint5_linear_283_18165)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_283_18165",
    x: 10.4766,
    y: 7.75342,
    width: 31.9688,
    height: 26.0225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.24415
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.99189 0 0 0 0 0.840511 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_283_18165",
    x: 0.974609,
    y: 4.12988,
    width: 54.0488,
    height: 49.0332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.31775
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24415
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.979685 0 0 0 0 0.845101 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_283_18165",
    x: 32.3437,
    y: 1.77051,
    width: 12.7364,
    height: 14.2144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.48831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.740987 0 0 0 0 0.367269 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_283_18165",
    x: 1,
    y: 25.9941,
    width: 18.5391,
    height: 5.09766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.48831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.45151
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.724703 0 0 0 0 0.32749 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_283_18165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_18165",
    x1: 21.5458,
    y1: 14.2779,
    x2: 27.2875,
    y2: 23.0443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#FFD482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A20A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_18165",
    x1: 21.5458,
    y1: 14.2779,
    x2: 27.2875,
    y2: 23.0443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#FFD482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A20A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_18165",
    x1: 50.18,
    y1: 16.4417,
    x2: 9.89525,
    y2: 41.3149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175343,
    stopColor: "#FFC983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322647,
    stopColor: "#FFA72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665958,
    stopColor: "#FFEEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986264,
    stopColor: "#FFD087"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_283_18165",
    x1: 40.4164,
    y1: 11.1208,
    x2: 36.6908,
    y2: 17.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_283_18165",
    x1: 10.1938,
    y1: 29.3955,
    x2: 17.3221,
    y2: 28.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_283_18165",
    x1: 28,
    y1: 25.4998,
    x2: 34.9734,
    y2: 34.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown1);
export default __webpack_public_path__ + "static/media/crown_1.8d6b884620ce9c91ce283659e395fa63.svg";
export { ForwardRef as ReactComponent };